import { Component } from '@angular/core';
import { RichTextEditorComponent } from '../../../../components/shared/rich-textEditor/rich-textEditor.component';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-rfi-emails',
  standalone: true,
  imports: [
    RichTextEditorComponent,
    ReactiveFormsModule,
    CommonModule,
    MatIconModule,
  ],
  templateUrl: './rfi-emails.component.html',
  styleUrl: './rfi-emails.component.css',
})
export class RfiEmailsComponent {
  emailForm: FormGroup;
  showForm = false; // Initially hide the form
  toEmails: string[] = []; // To Emails
  ccEmails: string[] = []; // CC Emails
  bccEmails: string[] = [];

  constructor(private fb: FormBuilder) {
    this.emailForm = this.fb.group({
      to: ['Mia Taylor'],
      cc: ['Evelyn Scott'],
      bcc: ['sss'],
      subject: ['RFI #1: RFI-001 - Clarification on Design Layout'],
      message: ['Sent from BuildXY'],
    });
  }

  sendEmail() {
    console.log('Sending email:', this.emailForm.value);
  }

  addEmail(field: 'to' | 'cc' | 'bcc') {
    const email = this.emailForm.get(field)?.value.trim();

    if (email && !this[field + 'Emails'].includes(email)) {
      this[field + 'Emails'].push(email);
      this.emailForm.get(field)?.setValue(''); // Clear input after adding
    }
  }

  removeEmail(index: number, field: 'to' | 'cc' | 'bcc') {
    this[field + 'Emails'].splice(index, 1);
  }
}
